import React from 'react';
import { Helmet } from 'react-helmet';

const HelmetWrapper = ({ title }) => (
  <Helmet titleTemplate="f-Rent - %s" defaultTitle="f-Rent">
    <title>{title}</title>
  </Helmet>
);

export default HelmetWrapper;